import React from 'react';
import { Link } from 'react-router-dom';
import { Send, Instagram } from 'lucide-react';

const Footer = () => (
  <footer className="fixed bottom-0 left-0 right-0 z-40 glass border-t border-white/20 dark:border-white/10">
    <div data-nosnippet="" className="max-w-[1920px] mx-auto px-3 md:px-8 lg:px-12 py-2 md:py-4 flex flex-col md:flex-row items-center justify-between gap-1 md:gap-4 text-brand-text">
      <div className="flex w-full md:w-auto items-center justify-between gap-2 md:gap-6 whitespace-nowrap text-xs md:text-sm">
        <span><span className="hidden md:inline">2026 </span>tistore®</span>
        <a href="mailto:tistore@inbox.ru">tistore@inbox.ru</a>
        <div className="flex items-center gap-1 md:gap-2">
          <a href="https://t.me/tistore_tg" target="_blank" rel="noopener noreferrer" aria-label="Telegram" title="Telegram" className="p-1.5"><Send className="w-4 h-4" /></a>
          <a href="https://www.instagram.com/tistore_inst" target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram" className="p-1.5"><Instagram className="w-4 h-4" /></a>
          <a href="https://www.tiktok.com/@tistore_tt" target="_blank" rel="noopener noreferrer" aria-label="TikTok" title="TikTok" className="p-1.5">
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="w-4 h-4"><path d="M16.7 1h-3.5v15.1a3.2 3.2 0 1 1-2.8-3.2V9.3a6.8 6.8 0 1 0 6.3 6.8V8.4a9.4 9.4 0 0 0 5.5 1.8V6.6A5.6 5.6 0 0 1 16.7 1Z" /></svg>
          </a>
        </div>
      </div>
      <div className="flex items-center justify-between md:justify-end w-full md:w-auto gap-3 whitespace-nowrap text-xs md:text-sm">
        <Link to="/privacy_policy" aria-label="Политика конфиденциальности"><span className="md:hidden">Политика</span><span className="hidden md:inline">Политика конфиденциальности</span></Link>
        <Link to="/purchase-info">Продавец и возврат</Link>
        <button onClick={() => window.dispatchEvent(new Event('tistore-cookie-settings'))} aria-label="Настройки cookies" className="underline"><span className="hidden md:inline">Настройки </span>cookies</button>
      </div>
    </div>
  </footer>
);

export default Footer;
